import { API_V2_BASE_URL } from '../api/config';
import ENDPOINTS from '../api/endpoints';

export const getAppDomain = (): string => {
  const url = window.location.href;
  const { hostname } = new URL(url);

  // Detect local development environments
  const isLocalhost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname);

  if (isLocalhost) {
    return 'https://biryanihouse.snapmenu.ai'
  }

  // Return the full URL with protocol (e.g., https://pizza.snapmenu.ai, https://sandboxtesting.snapmenu.ai)
  return `https://${hostname}`;
};

export const buildUrlWithDomain = (path: string): string => {
  const domain = getAppDomain();
  return `${API_V2_BASE_URL}${path}?domain=${domain}`;
};

export const buildRestaurantUrl = (): string => {
  const domain = getAppDomain();
  return `${API_V2_BASE_URL}${ENDPOINTS.RESTAURANT_DETAILS_API_PATH}?domain=${domain}`;
};
